import React, { useState } from 'react';
import { RulesRunner } from '../../rules/rulesRunner';
import { speakPhonemes } from '../../speak/speakPhonemes';

interface MakeUpWordsProps {
  /** knows how to make up valid words */
  wordMaker?: WordMaker;
  /** a converter from IPA to something else (e.g., English-like spelling),
   * if passed, the output will be displayed below the input area */
  fromIpa?: RulesRunner;
  /** number of columns in textarea, default 60 */
  cols?: number;
}
export interface WordMaker {
  makeWord(): string;
}

/** UI for generating & speaking a random word that follows phonotactics rules */
export function MakeUpWord(props: MakeUpWordsProps) {
  const [word, setWord] = useState('');
  const [approxIpa, setApproxIpa] = useState('');
  const [converted, setConverted] = useState('');
  const generator = props.wordMaker;
  const cols = props.cols ?? 60;

  function makeUpWord() {
    if (generator === undefined) return;
    const newWord = generator.makeWord();
    setWord(newWord);
    const toConverted = props.fromIpa ? props.fromIpa.runRulesOnIpa(newWord).ipa : '';
    setConverted(toConverted);
  }

  function makeUpSentence() {
    if (generator === undefined) return;
    const words: string[] = [1, 2, 3, 4, 5, 6].map(_ => generator.makeWord());
    const sentence = words.join(' ') + ' .';
    setWord(sentence);
    const toConverted = props.fromIpa ? props.fromIpa.runRulesOnIpa(sentence).ipa : '';
    setConverted(toConverted);
  }

  function speakWord() {
    const { approxIpa } = speakPhonemes(word);
    setApproxIpa(approxIpa);
  }

  return (<div>
    <button onClick={() => speakWord()}>speak</button>
    <button onClick={() => makeUpWord()}>make word</button>
    <button onClick={() => makeUpSentence()}>sentence</button>
    <textarea cols={cols} rows={1} spellCheck={false} value={word} onChange={(event) => setWord(event.target.value)} />
    <br />
    <span>{'pronounced as: /' + approxIpa + '/'}</span>
    <br />
    <span>{converted}</span>
  </div>);
}
